/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCategory } from '../models/work-category';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';

@Injectable({ providedIn: 'root' })
export class WorkCategoriesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `categoriesV2ControllerGetAllDropdownOptions()` */
  static readonly CategoriesV2ControllerGetAllDropdownOptionsPath = '/v2/categories/dropdown-options';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoriesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoriesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCategoriesV2Service.CategoriesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoriesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoriesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.categoriesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `categoriesV2ControllerGetAll()` */
  static readonly CategoriesV2ControllerGetAllPath = '/v2/categories/all';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoriesV2ControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoriesV2ControllerGetAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCategory>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCategoriesV2Service.CategoriesV2ControllerGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCategory>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoriesV2ControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoriesV2ControllerGetAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkCategory>> {
    return this.categoriesV2ControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCategory>>): Array<WorkCategory> => r.body)
    );
  }

}
